import PolicyDocument from "./PolicyDocument";

export default PolicyDocument;
